import { Alert, Grid } from '@mantine/core'
import { IconBounceRightFilled, IconCopy, IconInfoCircle } from '@tabler/icons-react'
import { SpeciLinesInformation } from '@shared/components/speci/speci-helpers/speci-helpers'

type SpeciLineWarningsProps = {
  speciLineCount: number
  speciLinesInformation: SpeciLinesInformation
}

export function SpeciLineWarnings({
  speciLineCount,
  speciLinesInformation,
}: SpeciLineWarningsProps) {
  const hasLines = speciLineCount > 0
  const skippedLines = hasLines && speciLinesInformation?.skipped
  const duplicateLines = hasLines && speciLinesInformation?.duplicates
  return (
    <Grid grow data-testid='speci-line-warnings'>
      {hasLines && (
        <Grid.Col span={{ base: 12, md: 1 }}>
          <Alert title='Bale numbers' icon={<IconInfoCircle />}>
            {`Min: ${speciLinesInformation?.min}, Max: ${speciLinesInformation?.max}`}
          </Alert>
        </Grid.Col>
      )}

      {skippedLines && (
        <Grid.Col span={{ base: 12, md: 1 }}>
          <Alert title='Skipped bale numbers' icon={<IconBounceRightFilled />} color='yellow'>
            {`Skipped: ${speciLinesInformation?.skipped?.join(', ')}`}
          </Alert>
        </Grid.Col>
      )}

      {duplicateLines && (
        <Grid.Col span={{ base: 12, md: 1 }}>
          <Alert title='Duplicate bale numbers' icon={<IconCopy />} color='red'>
            {`Duplicates: ${speciLinesInformation?.duplicates?.join(', ')}`}
          </Alert>
        </Grid.Col>
      )}
    </Grid>
  )
}
